import axios from 'axios';
import type { SectionItem, ModuleTemplate } from '../types/modules';

export default class SitemapService
{
    public static async getSitemap()
    {
        return (await axios.get<SitemapNode[]>(`admin/studio/modules/sitemap`, {
            params: {}
        })).data;
    }

    public static async fetch(symbol: string)
    {
        return (await axios.get<FormModel>(`admin/studio/modules/definition/${symbol}`)).data;
    }

    public static async fetchById(id: number)
    {
        return (await axios.get<FormModel>(`admin/studio/modules/definition/id/${id}`)).data;
    }
}

export interface SitemapNode
{
    name: string;
    icon: string;
    symbol: string;
    isHidden: boolean;
    template: ModuleTemplate;
    nodes: SitemapNode[];
}

export interface FormModel
{
    id: number;
    categoryId: number;
    name: string;
    symbol: string;
    icon: string;
    isActive: boolean;
    sections: SectionItem[];
}
